module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Media-library3-77f97e51804c7b6fc57cfd9618b2c32e.svg";